import * as React from 'react';

import { h2Style, pStyle } from '../../../styles';
import CongratsIcon from '../../icon.png';

type HeaderProps = {
  hasAvatar?: boolean;
  hasSearch?: boolean;
  hasIcon?: boolean;
  hasBurger?: boolean;
};

export const Header = (props: HeaderProps) => {
  return (
    <>
      <img
        alt=''
        style={{
          width: '120px',
          background: '#E0E0E0',
          borderRadius: '60px',
        }}
        src={CongratsIcon}
      />
      <h2 style={h2Style}>Congratulations</h2>
      <p style={pStyle}>
        Your registration has been successfully completed! Please complete your
        profile to get all the benefits of the app.
      </p>
      <p style={pStyle}>
        If you want to start using the app right now, just skip
      </p>
    </>
  );
};
